const $ = require('jquery');

const TermFilter = {
	$$: [],
	$label: [],
	$terms: [],
	active_class: 'is-active',
	init() {
		this.$$ = $('.js-term-filter');
		if ( this.$$.length > 0 ) {
			this.setup();
		}
	},
	setup() {
		this.$terms = this.$$.find('.js-term-filter-term');
		this.$target = $('.js-term-filter-target');
		this.$entries = this.$target.find('.js-term-filter-entry');
		this.$grid = this.$entries.parent('.vcex-post-type-grid');
		this.$$.on('click', '.js-term-filter-term', this.onClick.bind(this));
		$(document).on('activate.term-filter', this.onActivate.bind(this));
	},
	onActivate(e, subfilter) {
		if ( subfilter === 'none' ) {
			return $(document).trigger('filter-tiles', [ { term: '' }, this.$target, 'term-filter' ]);
		}

		this.$$.each((i, el) => {
			const $$ = $(el);
			if ( $$.is(subfilter) ) {
				const $active_item = $$.find(`.${this.active_class}`);
				if ( $active_item.length > 0 ) {
					const filter = this.buildFilter($active_item);
					$(document).trigger('filter-tiles', [ { term: filter }, this.$target, 'term-filter' ]);
				} else {
					$(document).trigger('filter-tiles', [ { term: '' }, this.$target, 'term-filter' ]);
				}
			}
		});
	},
	buildFilter($$) {
		return $$.data('termprefix')
			? `.${$$.data('termprefix')}-${$$.data('term')}`
			: $$.data('term')
		;
	},
	onClick(e) {
		const $$ = $(e.currentTarget);
		// Navigate if we have a link
		if ( $$.attr('href') ) {
			return true;
		}
		if ( this.isActive($$) ) {
			this.reset($$);
			return;
		}

		$$.addClass(this.active_class).siblings().removeClass(this.active_class);
		const $label = $$.parents('.js-term-filter').find('.js-term-filter-label');
		$label.text($$.text());
		const filter = this.buildFilter($$);
		$(document).trigger('filter-tiles', [ { term: filter }, this.$target, 'term-filter' ]);
		$('.js-term-filter-target').addClass('js-has-been-filtered');
	},
	isActive($$) {
		return $$.hasClass(this.active_class);
	},
	reset($$) {
		$$.siblings().removeClass(this.active_class);
		const $label = $$.parents('.js-term-filter').find('.js-term-filter-label');
		$label.text($label.data('defaultlabel'));
		$(document).trigger('filter-tiles', [ { term: '' }, this.$target, 'term-filter' ]);
	}
};
$(TermFilter.init.bind(TermFilter));
